//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const GameStats = require('@/tbs/model/vo/GameStats')
const DataConvertor = require('@/tbs/core/DataConvertor')
const ObjectFunc = require('@/tbs/util/ObjectFunc')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_GameStatsMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_GameStatsMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_GameStatsMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    handleCreationComplete: function() {
        // console.log('handleCreationComplete')
        if (this._bridge.isCreate()) {
            this.fetchTeamPlayers()
        }
        else {
            this.creationComplete()
        }
        this.target().game = ObjectFunc.mergeObject(ObjectFunc.cloneObject(this._bridge.getRouteQuery()), ObjectFunc.cloneObject(this._bridge.getRouteParam()))
    },
    handleDataLoad: function(parameters) {
        parameters.id = this._bridge.getRouteParam('gameId')
        parameters.playerId = this._bridge.getRouteParam('id')
        parameters.eventMode = 1
        return parameters
    },
    handleDataWrapped: function(viewData) {
        console.log('handleDataWrapped', viewData, this._bridge.isEdit())
        if (this._bridge.isEdit()) {
            const teamId = this._bridge.getRouteQuery('teamId')
            const homeTeamId = this._bridge.getRouteQuery('homeTeamId')
            const awayTeamId = this._bridge.getRouteQuery('awayTeamId')
            const selectedPlayer = viewData
            console.log('selectedPlayer', selectedPlayer)
            this.target().selectedTeamId = teamId
            this.target().selectedPlayer = selectedPlayer
            if (teamId === homeTeamId) {
                this.target().playerList.homeTeamPlayers = [selectedPlayer]
            }
            else if (teamId === awayTeamId) {
                this.target().playerList.awayTeamPlayers = [selectedPlayer]
            }
            return false
        }
        else {
            return true
        }
    },
    handleDataLoaded: function() {
        console.log('@handleDataLoaded')
        if (this._bridge.isCreate()) {
            const playerId = this._bridge.getRouteQuery('playerId')
            const teamId = this._bridge.getRouteQuery('teamId')
            let playerList
            if (teamId && playerId) {
                if (teamId == this._bridge.getRouteQuery('homeTeamId')) {
                    playerList = this.target().playerList.homeTeamPlayers
                }
                else {
                    playerList = this.target().playerList.awayTeamPlayers
                }
                let selectedPlayer
                for (let i = 0; i < playerList.length; i++) {
                    let player = playerList[i]
                    if (playerId == player.id) {
                        selectedPlayer = player
                        break
                    }
                }
                console.log('@selectedPlayer', selectedPlayer)
                this.target().selectedTeamId = teamId
                this.target().selectedPlayer = selectedPlayer
            }
        }
    },
    handleUpdateService: function(e) {
        if (e.data.result == true) {
            this._bridge.back()
        }
    },
    fetchTeamPlayers: function() {
        console.log('fetchTeamPlayers')
        const self = this
        const convertor = new GameStats
        const type = 'manage'
        const source = convertor.view[type]
        const service = 'manageTeamPlayerList'
        const parameters = [
            { teamId: this._bridge.getRouteQuery('homeTeamId'), gameId: this._bridge.getRouteParam('gameId'), matchId: this._bridge.getRouteQuery('matchGroupId') },
            { teamId: this._bridge.getRouteQuery('awayTeamId'), gameId: this._bridge.getRouteParam('gameId'), matchId: this._bridge.getRouteQuery('matchGroupId') }
        ]
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('fetchTeamPlayers.data', e.data)
            let viewData = {}
            let dataSets = e.data.dataSets
            for (let i = 0; i < dataSets.length; i++) {
                let dataSet = dataSets[i]
                if (dataSet.result) {
                    let item = convertor.view[type][i]
                    console.log('dataSet', dataSet)
                    const transformedData = DataConvertor.doTransform(convertor, item.basePath, item.rule, dataSet.payload, type)
                    if (viewData[item.name]) {
                        ObjectFunc.mergeObject(viewData[item.name], transformedData)
                    }
                    else {
                        viewData[item.name] = transformedData
                    }
                }
            }
            const wrapper = DataConvertor.wrapper(convertor)
            console.log('@wrapper-viewData', wrapper, viewData)
            // console.log('@target', self.target(), wrapper)
            if (self.handleViewDataWrap(viewData)) {
                if (wrapper) {
                    self.target()[wrapper] = viewData
                }
                else {
                    for (let p in viewData) {
                        self.target()[p] = viewData[p]
                    }
                }
            }
            self.handleDataLoaded(e)
        })
        self._bridge.callResourceInstance(service, {
            services: ObjectFunc.extractProperties(source, ['baseUrl', 'apiPrefix', 'apiSuffix', 'service']),
            method: 'GET',
            parameters: parameters
        }, true)
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_GameStatsMediator, BaseMediator);

module.exports = tbs_controller_GameStatsMediator